// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__E3AUO","avatar_picture":"Avatar_avatar_picture__asm48"};